import { showErrorMessage } from "../../common/Toaster";
import jwtAxios from "../../services/axiosInstance/ApiConfig";
import { FETCH_START, FETCH_SUCCESS, FETCH_ERROR } from "../types/actions/Common.actions";
import { SET_DASHBOARD_DATA } from "../types/actions/Dashboard.actions";

export const onGetDashboardData = () => {
	return async (dispatch: any) => {
		try {
			dispatch({ type: FETCH_START })
			const resp = await jwtAxios.get('/dashboard/getData')
			if (resp && resp.status === 200) {
				dispatch({ type: FETCH_SUCCESS })
                dispatch({ type: SET_DASHBOARD_DATA, payload: resp.data })
			} else {
				showErrorMessage('Something went wrong!')
			}
		} catch (err: any) {
			console.log("err ", err)
			dispatch({ type: FETCH_ERROR, error: err })
			showErrorMessage(err)
		}
	};
};
